import { useMemo } from 'react'

import { useGatewaysStore } from '@common/modules/gateways/stores'
import { useProjectsStore } from '@common/modules/projects/stores'

import { buildGatewayNode } from './tree-builders'
import { projectMatchesGatewayFetch } from './utils/projectMatchesGatewayFetch'

export function useFilteredGateways() {
  return useGatewaysStore((state) => state.gateways)
}
/**
 * Derives the service map tree from the current project and gateways.
 * Built synchronously so consumers (dashboard, service map) are not one effect behind the store.
 */
export function useServiceMapTree() {
  const currentProject = useProjectsStore((s) => s.currentProject)
  const gateways = useGatewaysStore((s) => s.gateways)
  const lastFetchedProjectId = useGatewaysStore((s) => s.lastFetchedProjectId)

  return useMemo(() => {
    if (!currentProject?.id) {
      return []
    }
    if (!projectMatchesGatewayFetch(currentProject.id, lastFetchedProjectId)) {
      return []
    }
    return gateways.map((gateway) => buildGatewayNode(gateway))
  }, [currentProject, lastFetchedProjectId, gateways])
}
